
import { View } from 'backbone';
import util     from 'util/Util.js';
import fileAttachmentTemplate from 'properties/table/column-main-file-button.ejs';

// PF-5745
import undoService from 'UndoService';
import textConstants from 'TextConstants';

class MainButtonPositionView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.tagName = 'div';
        this.id = opts.el;
        this.colId = this.model.get('selectedRowId');

        this.events = {
            'change input[type=checkbox]' : 'updateCheckboxAttributes'
        };

        if(this.colId){
            let factorykey=this.model.get('gridData')[this.colId].get('factoryKey');
            util.updateHelpDocumentationLink(factorykey);
        }
         this.template = fileAttachmentTemplate;

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    get columnModel() {
        return this.model.get('gridData')[this.colId];
    }

    updateCheckboxAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.checked;
        const oldPropVal = this.columnModel.attributes[propName];
        var columnModel = this.columnModel;

        if (propVal) {
            this.columnModel.attributes['buttonPosition'] = 'left';
        } else {
            this.columnModel.attributes['buttonPosition'] = 'right';
        }
        this.columnModel.attributes[propName] = propVal;
        this.columnModel.trigger('change');

        undoService.add({
            undo: () => {
                if (oldPropVal) {
                    columnModel.attributes['buttonPosition'] = 'left';
                } else {
                    columnModel.attributes['buttonPosition'] = 'right';
                }
                columnModel.attributes[propName] = oldPropVal;
                this.render();  
            },
            redo: () => {
                if (propVal) {
                    columnModel.attributes['buttonPosition'] = 'left';
                } else {
                    columnModel.attributes['buttonPosition'] = 'right';
                }
                columnModel.attributes[propName] = propVal;
                this.render();  
            }
        }, textConstants.UNDO_MOVE);

    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.columnModel.toJSON()));
        }

        let buttonPositionLeft = util.isTrue(this.columnModel.get('buttonPositionLeft'));
        $(`input[name='buttonPositionLeft']`).prop('checked', buttonPositionLeft );

        this.delegateEvents();
        return this;
    }

}

export default MainButtonPositionView;
